














































import PaymentMethodAccordionV2 from '@accounting/components/others/payment-method-accordion-v2.vue';
import { PaymentMethodInfo, PaymentMethodOption } from '@activities/interfaces/activity';
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';

@Component({
  name: 'bpc-choose-payment-method-step',
  components: {
    'bpc-payment-method-accordion-v2': PaymentMethodAccordionV2,
  },
})
export default class ChoosePaymentMethodStep extends Vue {
  // PROPS
  @Prop({
    type: Number,
  })
  readonly sessionId: number;
  @Prop({
    type: Number,
  })
  readonly contactId: number;
  // @Prop({
  //   type: Boolean,
  // })
  // readonly loadingPaymentMethods: boolean;
  @Prop({
    type: Boolean,
  })
  readonly savingPaymentMethod: boolean;
  @Prop({
    type: Object,
    default() {
      return {
        payment_method: null,
        subscription: null,
      };
    },
  })
  readonly value: { payment_method: string; subscription: number };

  // DATA
  loadedPaymentMethods = false;
  paymentMethodInfo: PaymentMethodInfo = null;
  paymentMethodOptions: PaymentMethodOption[] = [];
  subscriptionOptions: {
    id: number;
    label: string;
    disabled: boolean;
    subscription_category_id: number;
  }[] = [];
  isFree = false;
  // COMPUTED
  get model() {
    return this.value;
  }

  set model(value) {
    this.$emit('input', value);
  }

  get selectedPaymentMethod(): string {
    return this.model?.payment_method;
  }

  @Watch('selectedPaymentMethod')
  onChangeSelectedPaymentMethod(value) {
    if (value === 'subscription' && this.subscriptionOptions.length) {
      const validSubscription = this.subscriptionOptions.find(item => !item.disabled);
      if (validSubscription) {
        this.model.subscription = validSubscription.id;
      }
    }
  }

  // LIFECYCLE
  async mounted() {
    this.loadPaymentMethods();
  }

  async loadPaymentMethods() {
    this.loadedPaymentMethods = false;
    try {
      // Api call
      const basePath = this.$bpcApiRouteHelper.getEntityPath('activity-sessions');
      const path = `${basePath}/${this.sessionId}/contact-payment-methods/${this.contactId}`;
      const res = await this.$bpcApi.get(path, null, 'admin').toPromise();

      this.paymentMethodInfo = res.data;
      this.setPaymentMethodOptions();
      this.setSubscriptionOptions();
      this.$emit('payment-methods-loaded', this.paymentMethodOptions);
      this.$emit('options-loaded', res.data.options);
    } catch (error) {
      this.manageLoadPaymentMethodsErrors(error);
    }
    this.loadedPaymentMethods = true;
  }

  manageLoadPaymentMethodsErrors(error) {
    console.log(error);
  }

  setSubscriptionOptions() {
    this.subscriptionOptions = (this.paymentMethodInfo?.contactValidSubscriptions || []).map(
      subscriptionInfo => {
        const remainingStr = `[${this.$t('global.subscription.remaining_credits.label')}: ${
          subscriptionInfo.remaining_credits ? subscriptionInfo.remaining_credits : 0
        }]`;
        return {
          id: subscriptionInfo.id,
          label: `${subscriptionInfo.code} [${subscriptionInfo.subscription_category_name}] ${remainingStr}`,
          disabled: !subscriptionInfo.valid_credits_number,
          subscription_category_id: subscriptionInfo.subscription_category_id,
        };
      },
    );
  }

  setPaymentMethodOptions() {
    const paymentMethodOptions = [];
    this.isFree = false;
    // if (this.paymentMethodInfo.payWithSubscriptionsAllowed) {
    //   this.paymentMethodInfo.contactValidSubscriptions.forEach(subscription => {
    //     paymentMethodOptions.push({
    //       value: `subscription_${subscription.id}`,
    //       text: `${this.$t('global.subscription.subscription')} ${subscription.code}`,
    //       description: `${this.$t('global.subscription.subscription')} ${subscription.code} (${
    //         subscription.subscription_category_name
    //       })`,
    //     });
    //   });
    // }

    // NOTE if is free do not add more payment methods
    if (this.paymentMethodInfo.isFree) {
      // paymentMethodOptions.push({
      //   value: 'free',
      //   text: this.$t('global.payment_method.free.label'),
      //   description: this.$t('global.payment_method.free.description'),
      // });

      this.model = {
        payment_method: 'free',
        subscription: null,
      };

      this.isFree = true;
    }
    // NOTE if not free add payment methods
    else {
      if (this.paymentMethodInfo.payWithSubscriptionsAllowed) {
        paymentMethodOptions.push({
          value: 'subscription',
          text: this.$t('global.payment_method.subscription.label'),
          description: this.$t('global.payment_method.subscription.description'),
        });
      }
      if (this.paymentMethodInfo.payWithBancontactAllowed) {
        paymentMethodOptions.push({
          value: 'stripe_bancontact',
          text: this.$t('global.payment_method.bancontact.label'),
          description: this.$t('global.payment_method.bancontact.description'),
        });
      }
      if (this.paymentMethodInfo.payWithCreditCardAllowed) {
        paymentMethodOptions.push({
          value: 'stripe_card',
          text: this.$t('global.payment_method.stripe.label'),
          description: this.$t('global.payment_method.stripe.description'),
        });
      }
      if (this.paymentMethodInfo.payWithMoneyTransferAllowed) {
        paymentMethodOptions.push({
          value: 'money_transfer',
          text: this.$t('global.payment_method.money_transfer.label'),
          description: this.$t('global.payment_method.money_transfer.description'),
        });
      }
      if (this.paymentMethodInfo.payWithPayFipAllowed) {
        paymentMethodOptions.push({
          value: 'payfip',
          text: this.$t('global.payment_method.payfip.label'),
          description: this.$t('global.payment_method.payfip.description'),
        });
      }
      // if (this.paymentMethodInfo.payWithCashAllowed) {
      //   paymentMethodOptions.push({
      //     value: 'cash',
      //     text: this.$t('global.payment_method.cash.label'),
      //     description: this.$t('global.payment_method.cash.description'),
      //   });
      // }
    }
    this.paymentMethodOptions = paymentMethodOptions;
  }
}
